import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { SocketIOContextProvider } from './contexts/SocketIOContext';
import { HelmetProvider } from 'react-helmet-async';
import { ChakraProvider } from '@chakra-ui/core';
import theme from './theme';
import AppCrashFallback from './views/AppCrashFallback';
import { initAnalytics } from './analytics';
import { initSentry } from './observability';

initSentry();
initAnalytics();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <HelmetProvider>
        <SocketIOContextProvider>
          <ChakraProvider theme={theme}>
            <Sentry.ErrorBoundary
              fallback={({ resetError }) => (
                <AppCrashFallback onReset={resetError} />
              )}>
              <App />
            </Sentry.ErrorBoundary>
          </ChakraProvider>
        </SocketIOContextProvider>
      </HelmetProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
